export enum QUEUE_TYPE {
  CHECKED_IN = "checkin",
  COMPLETED = "completed",
  BOOKED = "booked",
  FOLLOWUP = "followup",
  OTHERS = "others",
  BILLING = "billing",
  REQUESTED = "requested",
}

export enum RIGHT_PANEL_VIEW_TYPE {
  DEFAULT = "default",
  COMPACT = "compact",
}

export enum CHECKED_IN_STATUS {
  "UP_NEXT" = "UP_NEXT",
  "ON_GOING" = "ON_GOING",
  "NO_STATUS" = "NO_STATUS",
}

export enum CUSTOM_SLOT_TYPE {
  TODAY = "today",
  TOMORROW = "tomorrow",
  SATURDAY = "saturday",
  CUSTOM = "custom",
}

export enum TIME_OF_DAY_FOR_SLOTS {
  MORNING = "morning",
  AFTERNOON = "afternoon",
  EVENING = "evening",
}

export const enum QUEUE_SORT_BY {
  WAITING_TIME_LOW_TO_HIGH = "waiting_time_low_to_high",
  WAITING_TIME_HIGH_TO_LOW = "waiting_time_high_to_low",
  APPOINTMENT_TIME_LOW_TO_HIGH = "appointment_time_low_to_high",
  APPOINTMENT_TIME_HIGH_TO_LOW = "appointment_time_high_to_low",
  TOKEN_NUMBER_LOW_TO_HIGH = "token_number_low_to_high",
  TOKEN_NUMBER_HIGH_TO_LOW = "token_number_high_to_low",
  VISIT_END_TIME_LOW_TO_HIGH = "visit_end_time_low_to_high",
  VISIT_END_TIME_HIGH_TO_LOW = "visit_end_time_high_to_low",
}
